<label class="switch" (click)="onClick($event)">
  <input type="checkbox" [checked]="checked">
  <span class="slider round"></span>
</label>
